import styled, { css } from 'styled-components';
import {
  animations,
  colors,
  cssprops,
  getTypography,
  mathRound,
  pxToRem,
} from '@vfit/shared/themes';
import { IOtpInputForStyledComponents } from './otpInput.models';

const fadeAnimation = css`
  &.enter {
    animation: ${animations.fadeIn} 0.3s forwards;
  }

  &.exit {
    animation: ${animations.fadeOut} 0.3s forwards;
  }
`;

const variants = {
  cells: {
    sunrise: css<IOtpInputForStyledComponents>`
      column-gap: ${pxToRem(8)};
    `,
    mva: css<IOtpInputForStyledComponents>`
      column-gap: ${pxToRem(16)};
    `,
  },
};

export const Container = styled.div<IOtpInputForStyledComponents & cssprops.IStyled>`
  ${({ hidden }) => (hidden ? 'visibility: hidden;' : '')}
  padding-bottom: ${({ errorLines }) =>
    pxToRem(errorLines && errorLines > 0 ? mathRound(mathRound(errorLines, 0) * 18) + 8 : 18 + 8)};
  position: relative;
  ${cssprops.styled}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Cells = styled.div<IOtpInputForStyledComponents>`
  display: flex;
  ${({ variant }) => (variant ? variants.cells[variant] : '')}
`;

export const ErrorMessage = styled.p<IOtpInputForStyledComponents>`
  ${getTypography('footnote1.regular')}
  ${fadeAnimation}
  bottom: 0;
  color: ${colors.$bd0000};
  display: flex;
  height: ${({ errorLines }) =>
    pxToRem(errorLines && errorLines > 0 ? mathRound(mathRound(errorLines, 0) * 18) : 18)};
  justify-content: center;
  left: 0;
  margin: 0;
  position: absolute;
  text-align: center;
  width: 100%;
`;

